import { Deserializable } from '../protocols/deserializable';
import * as moment from 'moment';

export class LumpSumPaymentInstruction implements Deserializable {
  public id!: string; // GUID
  public paymentAmount!: number;
  public desiredPaymentDate!: string;

  // Not from API
  public formattedDesiredPaymentDate!: string;
  public formattedDesiredPaymentMonthYear!: string;

  public onDeserialize(): void {
    if (this.desiredPaymentDate) {
      const desiredPaymentDate = moment(this.desiredPaymentDate.split('T')[0]);
      this.formattedDesiredPaymentDate = desiredPaymentDate.format('MMMM DD, YYYY');
      this.formattedDesiredPaymentMonthYear = desiredPaymentDate.format('MMMM, YYYY');
    }
  }
}
